import * as React from "react";
import {useState, useEffect} from "react";
import { CheckboxInput } from "common/src/forms/CheckboxInput";

const delay = !!window.OPSEEKER_CONFIG.CHECKBOX_DELAY ? parseInt(window.OPSEEKER_CONFIG.CHECKBOX_DELAY) : 500

export const DbotCheckboxButton = (props) => {
    const [value, setValue] = useState(false)
    useEffect(() => {
        if (!value) return;
        setTimeout(() => {
            props.onclick(props.button)
        }, delay)
    }, [value])
    return (
        <CheckboxInput value={value} setValue={setValue} label={props.button.view.payload}/>
    )
}

